import MellowMarkdown from './MellowMarkdown';
import { useSmoothStream } from '../hooks/useSmoothStream';

/**
 * StreamingMellowMessage - Smooth streaming text component for Mellow AI chat
 *
 * Displays text with smooth character-by-character animation while streaming,
 * then shows full content via MellowMarkdown when animation completes.
 *
 * Mirrors reedle-web's StreamingMessage but uses MellowMarkdown instead of ReedleMarkdown.
 *
 * @param {string} props.text - Current message content (from chats$ at threshold)
 * @param {boolean} props.isStreaming - Whether the network is still streaming (NETWORK_STREAMING state)
 * @param {object} props.streamBufferRef - Shared ref written by SSE handler, read by RAF loop
 * @param {object} props.visibleLengthRef - Tracks animation position for abort truncation
 * @param {function} props.onAnimationComplete - Called when animation catches up to full buffer
 * @param {boolean} props.forceComplete - Freeze animation at current position (stop button)
 * @param {string} props.chatId - Chat ID for MellowMarkdown card saving
 * @param {number} props.messageIndex - Message index for MellowMarkdown
 * @param {string} props.languageCode - Language code for MellowMarkdown
 * @param {string} props.initialMode - Chat initial mode for MellowMarkdown
 */
const StreamingMellowMessage = ({
  text,
  isStreaming = false,
  streamBufferRef,
  visibleLengthRef,
  onAnimationComplete,
  forceComplete = false,
  chatId,
  messageIndex,
  languageCode,
  initialMode,
}) => {
  const visibleContent = useSmoothStream(
    text,
    isStreaming,
    8,
    onAnimationComplete,
    forceComplete,
    streamBufferRef,
    visibleLengthRef,
  );

  return (
    <MellowMarkdown
      chatId={chatId}
      messageIndex={messageIndex}
      languageCode={languageCode}
      initialMode={initialMode}
    >
      {visibleContent}
    </MellowMarkdown>
  );
};

export default StreamingMellowMessage;
